import React from "react";
import { ThemeProvider } from "theme-ui";

import theme from "./theme";

function withTheme<T>(Component: React.FC<T>) {
  return (props: T) => (
    <ThemeProvider theme={theme}>
      <Component {...props} />
    </ThemeProvider>
  );
}

export default withTheme;
